<template>
  <div>
    <barcode-range-config v-for="range in ranges"
      v-bind:key="range.id"
      :config="range"
      v-on:range-updated="updateRange($event, range)"
      v-on:range-deleted="deleteRange(range)"
    ></barcode-range-config>
    <p><a href v-on:click.prevent="addRange">Add range</a></p>
    <input type="hidden" :name="name" :value="stringifyConfig">
  </div>
</template>

<script>
import barcodeRangeConfig from './barcode-range-config.vue'
export default {
  components: {
    'barcode-range-config' : barcodeRangeConfig,
  },
  props: {
    name: {
      type: String,
      required: true
    },
    enable: {
      type: Boolean,
      default: false,
    },
    config: {
      default: null,
    },
  },
  data: function() {
    return{
        ranges: [],
    }
  },
  computed: {
    stringifyConfig: function() {
      let config = {
        enable: this.enable,
        ranges: this.ranges
      }
      return JSON.stringify(config);
    }
  },
  methods: {
    addRange() {
      let id = null;
      if(this.ranges.length > 0) {
        id = Number(_.max(_.reduce(this.ranges, function(result, value, key) {
            result.push(value.id);
            return result;
          }, []))) + 1;
      } else {
        id = _.uniqueId();
      }
      this.ranges.push({
        id: id,
        type: null,
        start: null,
        end: null,
      })
    },
    updateRange(e, range) {
      this.ranges.splice(_.indexOf(this.ranges, range), 1, e);
    },
    deleteRange(range) {
      this.ranges.splice(_.indexOf(this.ranges, range), 1);
    },
  },
  mounted() {
    if(this.config) {
      this.ranges = this.config.ranges;
    }
  }
}
</script>

<style>

</style>
